import type { Workflow } from '@fv/models'

import { useQuoteSettings } from './settings'

export const useEnabledCarriers = (workflow: Workflow) => {
  const quoteSettingsQuery = useQuoteSettings(workflow)
  return quoteSettingsQuery.data?.apiEnabledCarriers ?? []
}
